import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase.js';
import { flattenAuthNavItems } from './navMenu.js';

const MAX_QUICK_LINKS = 8;

function resolveQuickLinkItems(paths) {
  const map = new Map(flattenAuthNavItems().map((item) => [item.path, item]));
  return (paths || []).map((path) => map.get(path)).filter(Boolean).slice(0, MAX_QUICK_LINKS);
}

export default function DashboardQuickLinks({ user }) {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLinks([]);
      setLoading(false);
      return undefined;
    }
    let active = true;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'user_preferences', user.uid));
        const paths = snap.exists() ? snap.data().quickLinks : [];
        if (active) setLinks(resolveQuickLinkItems(paths));
      } catch (err) {
        console.error('Quick links load error:', err);
        if (active) setLinks([]);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [user]);

  if (loading || links.length === 0) return null;

  return (
    <section className="dashboard-quick-links">
      <div className="dashboard-quick-links-head">
        <h2 className="dashboard-section-title">Your Quick Links</h2>
        <Link to="/preferences" className="dashboard-quick-links-edit">
          Edit in Preferences
        </Link>
      </div>
      <div className="quick-links-grid">
        {links.map((item) => (
          <Link key={item.path} to={item.path} className="quick-link-card">
            <strong>{item.label}</strong>
            <span>Jump to {item.label}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}